export default function CommandTranslateFilter(gettextCatalog, CommandsTextService) {
  'ngInject';

  const toFriendlyText = (text) =>
    (text || '')
      .split('_')
      .map(([first = '', ...rest] = '') => `${first.toUpperCase()}${(rest || []).join('')}`)
      .join(' ');

  return function (text) {
    if (!text) return '';

    //use command text map to override if exist or just try to make it readable
    text = CommandsTextService.commandsTextMap[text] || toFriendlyText(text);

    return gettextCatalog.getString(text);
  };
}
